import { Filtro } from './componentes';

/**
 * «Todas · Verano 2027 · Invierno 2027»: para contar, pedir o mirar solo lo de
 * una temporada. No sale si ninguna prenda dice la suya.
 */
export function FiltroDeTemporada({
  temporadas,
  elegida,
  alElegir,
}: {
  temporadas: readonly string[];
  elegida: string | null;
  alElegir: (temporada: string | null) => void;
}) {
  if (temporadas.length === 0) return null;

  return (
    <div className="filtros">
      <span className="apagado">Temporada</span>
      <Filtro texto="Todas" activo={elegida === null} onClick={() => alElegir(null)} />
      {temporadas.map((temporada) => (
        <Filtro key={temporada} texto={temporada} activo={elegida === temporada} onClick={() => alElegir(temporada)} />
      ))}
    </div>
  );
}
